<template>
  <div>
    <header>
      <div class="input-group">
        <input type="number" title="Enter Zipcode for Lunar Fishing Calendar" style="font-size: 16px;" id="zipCode" v-model="zipcode"
          class="form-control" @keypress.enter="getZipCodeChart" placeholder="Enter Zip Code" aria-describedby="basic-addon2">
        <span title="Get Lunar Fishing Calendar" class="input-group-addon sbt" @click="getZipCodeChart" id="getChart">GET CHART</span>
      </div>
      <span id="drr"></span>
    </header>
    <section class="row hunt">
      <div class="col-lg-12">
        <h3>SOLUNAR DATA</h3>
        <div class="row">
          <div class="col-lg-5 col-md-12">
            <p>
              Experienced fishermen around the country have long known that fish and other wildlife respond strongly to lunar phases. If
              you have witnessed a hot bite one day and a slow bite a few days later, then you know exactly what we are talking
              about. Fishing can be much better during certain times of the month.
            </p>
            <p>
              Our lunar fishing calendar predicts a general fishing forecast based on moon phases, sunrise, and sunset data. Local conditions,
              weather fronts, and barometric pressure can also affect fish activity. Many fishermen keep a journal detailing
              weather information to help determine the patterns and fishing strategies that work best for different seasons
              and weather scenarios, and we recommend you do the same. During the summer months, when the weather is hot,
              plan on fishing in the early morning or in the evening. During the winter, great fishing can be had during
              the middle of the day.
            </p>
            <p>
              According to John Alden Knight's famous Solunar Theory, fish become more active and feeding increases during two major periods
              each day and increases to a lesser extent during two minor periods each day. Major Feeding Times occur when
              the moon is directly overhead a point on the Earth's surface or directly below and Minor Feeding Times occur
              during moon rise and moon set, when the moon is on the horizon.
            </p>
          </div>
          <div class="col-lg-7 col-md-12">
            <div class="text-center">
              <!-- <i class="fa fa-line-chart fa-chart"></i> -->
              <img class="img-responsive" alt="Graphic depiction of major and minor feeding times" title="Lunar Major Feeding Times" src="/static/img/Lunar-Major-Feeding-Times.jpg">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ad row">
      <div class="col">
        <h3>LOCATION SPECIFIC CHARTS</h3>
        <p>
          Use our free online tool to make the most out of your time on the water. The charts will forecast fish activity for any US
          state based on your zipcode and show you the best fishing days in your area.
        </p>
        <p>
          Good luck and remember that a bad day of fishing is better than a good day of work!
        </p>
        <a title="Lunar Fishing Calendar" href="/lunar-fishing-calendar">
          <button alt="Free lunar fishing calendar" class="btn btn-primary btn-lg">Lunar Fishing Calendar</button>
        </a>
        <br/>
        <br/>
      </div>
    </section>

    <section class="row hunt">
      <div class="col-lg-12">
        <h3>FISHING FOR LARGEMOUTH BASS</h3>
        <p>
          For many people, the largemouth bass holds a special place in their hearts. It was the first fish they caught and helped
          spark a life long passion for fishing and enjoying the outdoors with family and friends. The largemouth bass, aptly
          named for its huge mouth, is extremely prolific and prospers in every continental U.S. state. It can be found in
          rivers, lakes and nearly every golf course, neighborhood or farm pond in the nation. With its very large mouth,
          the largemouth has evolved to be an aggressive predator, feeding on everything from frogs, bugs, and smaller fish
          to mice and even baby ducks.
        </p>
        <a title="Fishing for largemouth bass" href="/largemouth-bass-fishing">
          <button class="btn btn-primary btn-lg">Read More</button>
        </a>
      </div>
    </section>

    <section class="act row">
      <div class="col">
        <adsense class="adsbygoogle" ad-client="ca-pub-1632304178786452" ad-slot="8387166617" ad-style="display: block" ad-format="auto"></adsense>
      </div>
      <div class="col top-buffer">
        <h4>Also interested in Hunting? </h4>
      </div>
      <div class="col">
        <a href="https://www.deerfeedingchart.com">
          <button class="btn btn-default">Best Hunting Days</button>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Intro',
    data: function () {
      return {
        zipcode: ''
      }
    },
    methods: {
      getZipCodeChart() {
        this.$router.push('/lunar-fishing-calendar/' + this.zipcode)
      }
    },
    created: function () {
      window.document.title = 'Lunar Fishing Calendar | Fishing calendar for the best fishing days'
      if (this.$route.query.zipCode && this.$route.query.zipCode.length === 5) {
        this.$router.push('/lunar-fishing-calendar/' + this.$route.query.zipCode)
      }
    }
  }

</script>


// WEBPACK FOOTER //
// Intro.vue?7e878700